var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EAK',{attrs:{"url":"/api/v4/installations/disposals/types/:id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }